import { channelEntries } from "@/mocks/home";

export default function ChannelEntries() {
  return (
    <section id="channels" className="w-full bg-accent-50 border-y border-foreground-950/10">
      <div className="w-full px-4 md:px-10 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-12">
          <div>
            <p className="text-xs tracking-[0.3em] text-primary-600 font-medium">CHANNELS</p>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              渠道入口索引
            </h2>
          </div>
          <p className="text-sm md:text-base leading-7 text-foreground-600 max-w-md">
            名称、用途、可用度都列清楚了。建议一次性记住两到三个，某个不好用的时候随时切换。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-foreground-950/12">
          {channelEntries.map((item) => (
            <a
              key={item.name}
              href="#guide"
              className="group flex flex-col gap-4 p-5 md:p-7 bg-accent-50 border-b border-r border-foreground-950/12 hover:bg-background-50 transition-colors cursor-pointer"
            >
              <div className="flex items-start justify-between gap-4">
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-foreground-950 text-background-50">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <span className="px-2.5 py-0.5 rounded-full bg-background-50 border border-foreground-950/12 text-xs text-foreground-600 whitespace-nowrap">
                  {item.heat}
                </span>
              </div>

              <div className="flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">
                    {item.name}
                  </h3>
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-900 text-[11px] whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="mt-2.5 text-sm leading-6 text-foreground-600">{item.desc}</p>
              </div>

              <span className="inline-flex items-center gap-1.5 text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                查看使用步骤
                <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}